import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Empresa = () => {
  const wpp = generateWhatsAppLink('empresa', 'empresa-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Empresas | Sustenta LED</title>
        <meta name="description" content="Distribuidora e atacadista de LED para empresas. Soluções para escritórios, galpões, áreas internas e externas com equipe especializada." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Empresas</h1>
              <p>Atendemos empresas de diversos segmentos com soluções completas de iluminação LED. Somos atacadistas, distribuidores e representantes das principais marcas, com produtos para escritórios, galpões e áreas externas.</p>
              <p>Nossa consultoria técnica recomenda modelos e especificações conforme necessidade do ambiente, visando eficiência, conforto e economia.</p>
              <p>Com logística nacional e prazos rápidos, garantimos atendimento consultivo e condições exclusivas para empresas.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_empresa.jpg" alt="Luminárias de LED para Empresas - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Empresa;
